<template>
    <div class="copy-create">
        <InfoHeader title="计划复制详情任务" @backPage="handleBackPage"
            :style="{ position: 'fixed', zIndex: '99', top: '51px', width: '100%', transform: 'translateX(-10px)' }">
            <span>复制任务ID：{{ $route.query.id }}</span>
        </InfoHeader>
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
            <el-table :data="tableData" style="width: 100%;" stripe
                :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini" ref="toggleRowEx" class="create_vivo_list" v-loading="loading" tooltip-effect="dark">
                <el-table-column label="状态" width="120">
                    <template slot-scope="scope">
                        <template v-if="scope.$index == 0">
                            <span>汇总(成功/失败)</span>
                        </template>
                        <template v-else>
                            <p v-if="scope.row.status == 1" class="text-color-info">{{ scope.row.status_text }}<i
                                    class="el-icon-loading"></i></p>
                            <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text }}
                            </p>
                            <p v-else class="text-color-error">{{ scope.row.status_text }}<el-tooltip class="item"
                                    effect="dark" :content="scope.row.err_msg" placement="top-start"><i
                                        class="el-icon-warning-outline"></i></el-tooltip></p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="目标账户" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index == 0">-</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.account_name }}</p>
                            <br>
                            <p class="ellipsis">ID:{{ scope.row.account_id }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="投放产品" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index == 0">-</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.app_name }}({{ scope.row.app_id }})</p>
                            <br>
                            <p class="ellipsis">{{ scope.row.package_name }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="计划名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index == 0">{{ scope.row.success_plan_num }}/{{ scope.row.err_plan_num }}</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.plan_name }}</p>
                            <br />
                            <p class="ellipsis" v-if="scope.row.plan_id">ID:{{ scope.row.plan_id }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="广告组名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index == 0">{{ scope.row.success_adgroup_num }}/{{ scope.row.err_adgroup_num }}
                        </div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.adgroup_name }}</p>
                            <br />
                            <p class="ellipsis" v-if="scope.row.adgroup_id">ID:{{ scope.row.adgroup_id }}</p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="广告名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.$index == 0">{{ scope.row.success_ad_num }}/{{ scope.row.err_ad_num }}</div>
                        <div v-else>
                            <p class="ellipsis">{{ scope.row.ad_name }}</p>
                            <br />
                            <p class="ellipsis" v-if="scope.row.ad_id">ID:{{ scope.row.ad_id }}</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align: right;padding-top: 20px;">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>

        </div>
    </div>
</template>
<script>
import InfoHeader from "../components/infoHeader.vue";
import API from '@/api/marketManage/oppoCopyPlan.js'
export default {
    name: "copyInfoPage",
    components: { InfoHeader },
    data() {
        return {
            loading: false,  // 表格loading
            expanditemloading: false,  //创意详情loading
            currentPage: 1,
            pageSize: 10,
            total: 10,
            tableData: [],
            expandrowkeys: [],
            checkStatusTimer: null, // 添加定时器变量
            isComponentMounted: true,
        }
    },
    mounted() {
        this.getList({
            pn: this.currentPage,
            rn: this.pageSize,
            copy_id: this.$route.query.id
        })
    },
    methods: {
        handleBackPage() {
            this.$router.go(-1)
        },
        async getList() {
            try {
                let params = {
                    pn: this.currentPage,
                    rn: this.pageSize,
                    copy_id: this.$route.query.id
                }
                // 使用 Promise.all 同时发起两个请求
                const [listRes, totalRes] = await Promise.all([
                    API.getTaskDetailList(params),
                    API.getTaskDetailTotal(params)
                ]);
                
                // 检查接口返回状态码
                if (listRes.code !== 200 || totalRes.code !== 200) {
                    throw new Error(listRes.info || totalRes.info || '接口请求失败');
                }
                
                // 两个接口都成功返回后设置数据
                this.tableData = [totalRes.data, ...listRes.data.list];
                this.total = listRes.data.totalCnt
                this.checkTaskStatus(params)
            } catch (error) {
                // 处理错误
                this.$message.error(error.info || '获取数据失败');
            }
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.clearTimes()
            this.getList()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.clearTimes()
            this.getList()
        },
        checkTaskStatus(params) {
            // 清除之前的定时器
            if (this.checkStatusTimer) {
                clearTimeout(this.checkStatusTimer);
            }
            if (!this.isComponentMounted) return;
            
            // 创建新的定时器
            this.checkStatusTimer = setTimeout(() => {
                // 再次检查组件是否已卸载
                if (!this.isComponentMounted) {
                    if (this.checkStatusTimer) {
                        clearTimeout(this.checkStatusTimer);
                    }
                    return;
                }
                API.getTaskDetailTotal(params).then(res=>{
                    if (this.isComponentMounted) {
                        this.$set(this.tableData, 0, res.data)
                    }
                })
                API.getTaskDetailList(params).then(res => {
                    if (!this.isComponentMounted) return;
                    this.handleResponse(res);
                    
                    // 检查状态，如果包含0或1则继续请求
                    if (res.data.list.some(item => item.status == 0 || item.status == 1)) {
                        this.checkTaskStatus(params);
                    }
                }).catch(err => {
                    console.error('请求失败:', err);
                    if (this.checkStatusTimer) {
                        clearTimeout(this.checkStatusTimer);
                    }
                });
            }, 5000);
        },
        handleResponse(res) {
            // 处理返回数据的逻辑
            // 例如更新表格数据等
            let first_item = this.tableData[0] || []
            this.tableData = [first_item , ...res.data.list]
        },
        clearTimes() {
            if (this.checkStatusTimer) {
                clearTimeout(this.checkStatusTimer);
                this.checkStatusTimer = null; // 添加这行以确保完全清除
            }
        }
    },
    beforeDestroy() {
        // 清除定时器
        this.isComponentMounted = false;
        if (this.checkStatusTimer) {
            clearTimeout(this.checkStatusTimer);
            this.checkStatusTimer = null;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";
</style>